"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternLayout = InternLayout;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _pusherJs = _interopRequireDefault(require("pusher-js"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _InternAppBar = require("./InternAppBar");
var _InternDrawer = require("./InternDrawer");
var _InternSurface = require("./InternSurface");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function InternLayout(_ref) {
  var appId = _ref.appId,
    tenantId = _ref.tenantId,
    routes = _ref.routes;
  var _a, _b;
  var context = (0, _react.useContext)(_core.AppContext);
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var layoutContext = (0, _react.useContext)(_core.LayoutContext);
  var pusher = function () {
    var _a;
    if (!((_a = context.session) === null || _a === void 0 ? void 0 : _a.websocket)) return undefined;
    var websocket = context.session.websocket;
    if (websocket.name !== 'pusher') return undefined;
    _pusherJs["default"].logToConsole = websocket.verbose;
    var instance = new _pusherJs["default"](websocket.key, {
      cluster: websocket.cluster,
      forceTLS: websocket.encrypted
    });
    var channel = instance.subscribe(context.session.secret_id);
    channel.bind(websocket.event_name, function (payload) {
      if (payload.message.type === 'BLOCKED_USER') {
        layoutContext.blockUser();
      } else {
        feedbackContext.showInfo(payload.message.message);
      }
    });
    return instance;
  }();
  var onSignOut = function onSignOut() {
    if (pusher) pusher.disconnect();
    (0, _api.endAssistantSession)();
    context.removeSession();
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CssBaseline, null), /*#__PURE__*/_react["default"].createElement(_InternAppBar.InternAppBar, {
    appId: appId,
    email: (_b = (_a = context.session) === null || _a === void 0 ? void 0 : _a.user.email) !== null && _b !== void 0 ? _b : '',
    onSignOut: onSignOut
  }), /*#__PURE__*/_react["default"].createElement(_InternDrawer.InternDrawer, {
    tenantId: tenantId,
    routes: routes
  }), /*#__PURE__*/_react["default"].createElement(_InternSurface.InternSurface, {
    tenantId: tenantId,
    routes: routes
  }), /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    open: layoutContext.user.blocked,
    title: (0, _core.translate)('users.blocked.title'),
    onClose: onSignOut,
    closeText: (0, _core.translate)('buttons.signout')
  }, (0, _core.translate)('users.blocked.description')));
}